import React from 'react';
import { Link } from 'react-router-dom';
import { startHref, type InterestId } from '@/content/workflows';
import { cn } from '@/lib/utils';

interface StartButtonProps {
  interest?: InterestId;
  size?: 'sm' | 'default' | 'lg';
  className?: string;
  onClick?: () => void;
}

/** The site-wide primary action. Always reads "Start for free". */
const StartButton = ({ interest, size = 'default', className, onClick }: StartButtonProps) => (
  <Link
    to={startHref(interest)}
    onClick={onClick}
    className={cn('gc-btn gc-btn-primary', size === 'lg' && 'gc-btn-lg', size === 'sm' && 'gc-btn-sm', className)}
  >
    Start for free
    <span className="gc-arrow" aria-hidden="true">
      →
    </span>
  </Link>
);

export default StartButton;
